export var ToolsHeadingEnum;
(function (ToolsHeadingEnum) {
    ToolsHeadingEnum["Report"] = "Report";
    ToolsHeadingEnum["ReportSchedule"] = "Report Schedule";
    ToolsHeadingEnum["ViewMap"] = "View Map";
})(ToolsHeadingEnum || (ToolsHeadingEnum = {}));
